document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('.customer-account-popup .close_icon').addEventListener('click', () => {
      console.log('dkdkkdk')
    DOMAnimations.slideUp(document.querySelector("[data-account-dropdown]"));     
          document.body.classList.toggle("account-popup-open");
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const signIn = document.querySelector('#sign-in');
    const signUp = document.querySelector('#sign-up');
    const login = document.querySelector('#login');
    const register = document.querySelector('#register');
    const recover = document.querySelector('#recover .create-account-text a');
     const recoverlogin = document.querySelector('#popupEmailStep a[data-close="register"]');
 const recoverloginform = document.querySelector('.popup-register-form a[data-close="register"]');

 

    const forgotPassword = document.querySelector('.forgot-password-text')
    if (!signIn || !signUp || !login || !register || !forgotPassword || !recover || !recoverlogin  ) return;
    signIn.addEventListener('click', function () {
        signIn.classList.add('active');
        signUp.classList.remove('active');
        login.style.display = 'block';
        register.style.display = 'none';
         window.dispatchEvent(new Event('resize'));
    });
    signUp.addEventListener('click', function () {
        signIn.classList.remove('active');
        signUp.classList.add('active');

        login.style.display = 'none';
        register.style.display = 'block';
         window.dispatchEvent(new Event('resize'));
    });
    recoverlogin.addEventListener('click', function () {
         signIn.classList.add('active');
        signUp.classList.remove('active');
    })
     recoverloginform.addEventListener('click', function () {
         signIn.classList.add('active');
        signUp.classList.remove('active');
    });
    forgotPassword.addEventListener('click', function () {
        document.querySelector('.sign_in_tabs').style.display = 'none';
     });  
     recover.addEventListener('click', function () {
        document.querySelector('.sign_in_tabs').style.display = 'block';
     });      
});
 

document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.popup-slider-box');
    sliders.forEach(slider => {
        let flkty = null;
        function initSlider() {
            if (window.innerWidth < 768) {
                if (!flkty) {
                    flkty = new Flickity(slider, {
                        contain: true,
                        cellAlign: 'left',
                        pageDots: false,
                        prevNextButtons: false,
                        draggable: true,
                        wrapAround: false,
                        groupCells: true,
                        autoPlay: 3000,
                        pauseAutoPlayOnHover: false
                    });
                    setTimeout(() => {
                        flkty.resize();
                    }, 50);
                }
            } else {
                if (flkty) {
                    flkty.destroy();
                    flkty = null;
                }
            }            
        }
        initSlider();
        window.addEventListener('resize', initSlider);
    });
});
document.addEventListener('click', function (e) {
    if (e.target.closest('.header-icons-link account')) {
        document.querySelectorAll('.popup-slider-box').forEach(slider => {
            const flkty = Flickity.data(slider);
            if (flkty) {
                setTimeout(() => flkty.resize(), 100);
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
  const languageChanges = document.querySelectorAll('.js-language-change');
  if (!languageChanges.length) return;
  languageChanges.forEach(function (languagechange) {
    languagechange.addEventListener('click', function () {
      const langVal = this.getAttribute('language-name');
      const languageList = this.closest('body')
        .querySelector('.js-language-list');
      if (!languageList) return;
      if (langVal === 'en') {
        languageList.querySelector('button[value="th"]')?.click();
      } else {
        languageList.querySelector('button[value="en"]')?.click();
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const backButtons = document.querySelectorAll('.js-menu-back');
  if (!backButtons.length) return;
  backButtons.forEach(function (backBtn) {
    backBtn.addEventListener('click', function () {
      const innerChild = backBtn.closest('.inner-child');
      if (!innerChild) return;      
      const subSubActive = innerChild.querySelector(
        '.nav-item-header.active-bg'
      );
      if (subSubActive) {
        subSubActive.classList.remove('active-bg');
        subSubActive.classList.remove('active');
        return; 
      }
      const parentNavItem = innerChild.closest('.nav-item');
      if (!parentNavItem) return;

      const parentHeader = parentNavItem.querySelector('.nav-item-header.active-bg');
      if (parentHeader) {
        parentHeader.classList.remove('active-bg');
        parentHeader.classList.remove('active');
      }
    });
  });
  const menuToggler = document.querySelector('.mobileMenu');
  if (menuToggler) {
    menuToggler.addEventListener('click', function (event) { 
         event.preventDefault(); 
      document.querySelectorAll('.nav-item-header').forEach(function (el) {
        el.classList.remove('active', 'active-bg');
         el.classList.remove('active');
      });
    document.querySelectorAll('.nav-item-header').forEach(function (el) {
        el.classList.remove('active', 'active-bg');
         el.classList.remove('active');
      });
    });
  }

});

document.addEventListener("DOMContentLoaded", function () {
  const nextBtn = document.getElementById("emailNextBtn");
  const emailInput = document.getElementById("stepEmail");
  const errorMsg = document.querySelector(".email-error");
  const stepOne = document.getElementById("popupEmailStep");
  const registerForm = document.querySelector(".popup-register-form");
  const shopifyEmail = document.getElementById("RegisterForm-email");

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
    if (!nextBtn) return;
  nextBtn.addEventListener("click", function () {
    const email = emailInput.value.trim();

    if (!isValidEmail(email)) {
      errorMsg.style.display = "block";
      return;
    }
    errorMsg.style.display = "none";
    if (shopifyEmail) {
      shopifyEmail.value = email;
    }
    stepOne.style.display = "none";
    registerForm.style.display = "block";
  });


});

  document.addEventListener('click', function (e) {

  const mobileSignin = e.target.closest('.js-mobile-signin');
  const menuSignup = e.target.closest('.js-menu-signup');

  if (mobileSignin || menuSignup) {
    e.preventDefault();

    console.log('menu click detected');

    const accountLink = document.querySelector('a.header-icons-link.account');
    if (accountLink) {
      accountLink.click();
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".js-description-wrap").forEach(function (wrap) {
    const readMoreEl = wrap.querySelector("[read-more]");
    const readLessEl = wrap.querySelector("[read-less]");
    if (!readMoreEl || !readLessEl) return;
    readMoreEl.querySelector(".read-more-toggle").addEventListener("click", function () {
      readMoreEl.style.display = "none";
      readLessEl.style.display = "block";
    });   
    readLessEl.querySelector(".read-more-toggle").addEventListener("click", function () {
      readLessEl.style.display = "none";
      readMoreEl.style.display = "block";
    });

  });
});
/**Newsletter popup */

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.includes('/challenge')) {
    return;
  }
  const popup = document.getElementById('newsletterPopup');
  if (!popup) return;

  const formStep = popup.querySelector('.popup-form-step');
  const successStep = popup.querySelector('.popup-success-step');
  const closeBtn = popup.querySelector('.popup-close');
 
  if (localStorage.getItem('custom_newsletter_popup') === 'true') {
    return;
  }
  /* Show popup (session based) */
  if (!sessionStorage.getItem('custom_newsletter_popup')) {
    popup.style.display = 'flex';
    formStep.classList.add('active');
    successStep.classList.remove('active');
  }

  if (window.location.search.includes('customer_posted=true')) {
    popup.style.display = 'flex';
    formStep.classList.remove('active');
    successStep.classList.add('active');
    closeBtn.classList.add('active')
    localStorage.setItem('custom_newsletter_popup', 'true');
  }
  closeBtn.addEventListener('click', function () {
    if (closeBtn.classList.contains('active')) {
      formStep.classList.remove('active');
      successStep.classList.add('active');
      popup.style.display = 'none';
    const cleanUrl = window.location.origin + window.location.pathname;
  window.history.replaceState({}, document.title, cleanUrl);
    } else {
      popup.style.display = 'none';
      
    }
    sessionStorage.setItem('custom_newsletter_popup', 'true');
  });

});


document.addEventListener('DOMContentLoaded', function () {
  const sizeGuideTabs = document.querySelectorAll('.js-main-tab');
  const categoryTabs = document.querySelectorAll('.js-category-tab');
  if (!sizeGuideTabs.length || !categoryTabs.length) return;
  sizeGuideTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      const mainAttr = this.getAttribute('data-size-guide');   
      sizeGuideTabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      let firstVisibleSet = false;
      categoryTabs.forEach(function (catTab) {
        catTab.style.display = 'none';
        catTab.classList.remove('active');
        if (catTab.getAttribute('data-category') === mainAttr) {
          catTab.style.display = 'inline-block';
          if (!firstVisibleSet) {
            catTab.classList.add('active');
            firstVisibleSet = true;
          }
        }
      });
      const activeSizeTab = document.querySelector('.js-category-tab.active');
  if (activeSizeTab) activeSizeTab.click();
    });
  });

  
});
document.addEventListener('DOMContentLoaded', function () {
  const categoryTabs = document.querySelectorAll('.js-category-tab');

  if (!categoryTabs.length) return;

  categoryTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      const subCategory = this.getAttribute('sub-category-title');
      const parentElem = this.closest('.size-guide-wrapper');

      if (!parentElem) return;
      parentElem.querySelectorAll('.js-category-tab').forEach(t => {
        t.classList.remove('active');
      });
      this.classList.add('active');

      parentElem.querySelectorAll('.size-guide-content').forEach(function (content) {
        content.classList.remove('active');

        if (content.getAttribute('data-tab-content') === subCategory) {
          content.classList.add('active');
        }
      });
    });
  });
});





document.addEventListener('DOMContentLoaded', function () {
  /**Table Inches on click */
 document.querySelectorAll('.js-inches').forEach(function (btn) {
  btn.addEventListener('click', function () {
    const table = this.closest('table');
    if (!table) return;
    table.querySelectorAll('.js-inches, .js-cm').forEach(el => {
      el.classList.remove('active');
    });
    this.classList.add('active');
    table.querySelectorAll('.inche-table-data').forEach(el => {
      el.style.display = 'inline';
    });
    table.querySelectorAll('.cm-table-data').forEach(el => {
      el.style.display = 'none';
    });    
    table.querySelectorAll('tbody tr').forEach(tr => {
      const inchEls = tr.querySelectorAll('.inche-table-data');
      let hasValue = false;

      inchEls.forEach(el => {
        if (el.textContent.trim() !== '') {
          hasValue = true;
        }
      });

      tr.style.display = hasValue ? '' : 'none';
    });
  });
});

  /**Table CM on click */
document.querySelectorAll('.js-cm').forEach(function (btn) {
  btn.addEventListener('click', function () {
    const table = this.closest('table');
    if (!table) return;

    table.querySelectorAll('.js-inches, .js-cm').forEach(el => {
      el.classList.remove('active');
    });
    this.classList.add('active');
    table.querySelectorAll('.cm-table-data').forEach(el => {
      el.style.display = 'inline';
    });
    table.querySelectorAll('.inche-table-data, .inche-data').forEach(el => {
      el.style.display = 'none';
    });  
    table.querySelectorAll('tbody tr').forEach(tr => {
      const cmEls = tr.querySelectorAll('.cm-table-data');
      let hasValue = false;

      cmEls.forEach(el => {
        if (el.textContent.trim() !== '') {
          hasValue = true;
        }
      });

      tr.style.display = hasValue ? '' : 'none';
    });
  });
});

});
  /**Hide Empty Tr */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('table').forEach(table => {

    const isCmActive = table.querySelector('.js-cm.active');

    table.querySelectorAll('tbody tr').forEach(tr => {

      const inchEls = tr.querySelectorAll('.inche-table-data');
      const cmEls   = tr.querySelectorAll('.cm-table-data');
      if (inchEls.length === 0 && cmEls.length === 0) {
        tr.style.display = '';
        return;
      }

      let hasValue = false;

      if (isCmActive) {
        cmEls.forEach(el => {
          if (el.textContent.trim() !== '') {
            hasValue = true;
          }
        });
      } else {
        inchEls.forEach(el => {
          if (el.textContent.trim() !== '') {
            hasValue = true;
          }
        });
      }

      tr.style.display = hasValue ? '' : 'none';
    });

    // show  hide values
    if (isCmActive) {
      table.querySelectorAll('.cm-table-data').forEach(el => el.style.display = 'inline');
      table.querySelectorAll('.inche-table-data, .inche-data').forEach(el => el.style.display = 'none');
    } else {
      table.querySelectorAll('.inche-table-data').forEach(el => el.style.display = 'inline');
      table.querySelectorAll('.cm-table-data').forEach(el => el.style.display = 'none');
    }

  });
});


document.addEventListener("DOMContentLoaded", function () {
  const tables = document.querySelectorAll(".size-guide__size-chart");
  tables.forEach((table) => {
    const ths = table.querySelectorAll("thead th");
    const rows = table.querySelectorAll("tbody tr");
    ths.forEach((th, index) => {
      th.addEventListener("mouseenter", () => {     
        ths.forEach(el =>
          el.classList.remove("sibling-hover", "current-elm-hover")
        );
        rows.forEach(row =>
          row.querySelectorAll("td").forEach(td =>
            td.classList.remove("sibling-hover")
          )
        );
        th.classList.add("sibling-hover", "current-elm-hover");
        for (let i = 0; i < index; i++) {
          ths[i].classList.add("sibling-hover");
        }
        rows.forEach(row => {
          const tds = row.querySelectorAll("td");
          if (tds[index]) {
            tds[index].classList.add("sibling-hover");
          }
        });
      });
      th.addEventListener("mouseleave", () => {
        ths.forEach(el =>
          el.classList.remove("sibling-hover", "current-elm-hover")
        );
        rows.forEach(row =>
          row.querySelectorAll("td").forEach(td =>
            td.classList.remove("sibling-hover")
          )
        );
      });

    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const tbodies = document.querySelectorAll(".size-guide__size-chart-body");
  tbodies.forEach((tbody) => {
    const table = tbody.closest("table");
    const theadThs = table.querySelectorAll(".size-guide__size-chart-header th");
    const rows = Array.from(tbody.querySelectorAll("tr"));
    rows.forEach((row, rowIndex) => {
      const tds = Array.from(row.querySelectorAll("td"));
      tds.forEach((td, colIndex) => {
        const columnNth = colIndex + 1;
        td.addEventListener("mouseenter", () => {
          table.querySelectorAll("td, th").forEach(el => {
            el.classList.remove("sibling-hover", "current-elm-hover");
          });
          theadThs.forEach(th => {
            th.classList.remove("current-elm-hover");
          });
          td.classList.add("current-elm-hover", "sibling-hover");
          for (let c = 0; c < colIndex; c++) {
            if (tds[c]) {
              tds[c].classList.add("sibling-hover");
            }
          }
          for (let r = 0; r < rowIndex; r++) {
            const prevRowTd = rows[r].querySelector(
              `td:nth-child(${columnNth})`
            );
            if (prevRowTd) {
              prevRowTd.classList.add("sibling-hover");
            }
          }
          if (theadThs[colIndex]) {
            theadThs[colIndex].classList.add("sibling-hover");
          }
        });
        td.addEventListener("mouseleave", () => {
          table.querySelectorAll("td, th").forEach(el => {
            el.classList.remove("sibling-hover", "current-elm-hover");
          });
        });

      });
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-scroll-sec').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const index = this.getAttribute('scroll-index');
      const parent = this.closest('.size-guide-content');
      const target = parent.querySelector('.js-scroller[scrolling-section="' + index + '"]');

      if (!target) {
        console.log('target not found', index);
        return;
      }
 
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const wishlistIcon = document.querySelector(".js-customer-registertion");
  const wishlistPopup = document.querySelector(".customer-wishlist-popup");
    const wishlistClosePopup = document.querySelector(".customer-wishlist-popup .close_icon");
  if (!wishlistIcon || !wishlistPopup) return;
  wishlistPopup.style.display = "none";
  wishlistIcon.addEventListener("click", function (e) {
    e.preventDefault(); 
    wishlistPopup.style.display =  wishlistPopup.style.display === "block" ? "none" : "block";
    document.body.classList.add('wishlist-popup');
  });
wishlistClosePopup.addEventListener("click", function (e) {
    e.preventDefault(); 
     wishlistPopup.style.display = "none";
         document.body.classList.remove('wishlist-popup');
  });
  // outside click close
  document.addEventListener("click", function (e) {
    if (!wishlistPopup.contains(e.target) && !wishlistIcon.contains(e.target)) {
      wishlistPopup.style.display = "none";
              document.body.classList.remove('wishlist-popup');
    }
  });
});

/**Custom Card Wishlist */
document.addEventListener("click", function (e) {
  const wishlistBtn = e.target.closest('.js-wishlist-grid');
  if (!wishlistBtn) return;
  e.preventDefault();
  const registerLink = document.querySelector('a.js-customer-registertion');
  if (registerLink) {   
   setTimeout(() => {
       registerLink.click();
}, 50);
  } 

});

document.addEventListener("click", function (e) {
 const wislist_p = e.target.closest('.js-product-wislist')
  if(!wislist_p) return;
    e.preventDefault();
const registerLink = document.querySelector('a.js-customer-registertion');
  if (registerLink) {   
   setTimeout(() => {
       registerLink.click();
}, 50);
  } 

});


/**Pickup Size */

document.addEventListener('DOMContentLoaded', function () {
  const mobilefilter = document.querySelector('.js-mobile-filters');
  if (!mobilefilter) return;

  mobilefilter.addEventListener('click', function (event) {
    event.preventDefault();
    console.log('CLICK WORKING');

    document
      .querySelectorAll('.filter-drawer-body details[open]')
      .forEach(details => {
        details.removeAttribute('open');
      });
  });
});



document.addEventListener("click", function (e) {
  const applyBtn = e.target.closest(".js-apply-filters");
  if (!applyBtn) return;

  document.body.classList.remove('loaded');
            setTimeout(() => {
                  document.body.classList.add('loaded');
            }, 1500);
  const closeBtn = document.querySelector("a.filter-close-mobile");
  if (closeBtn) closeBtn.click();
});












